<template>
  <div ref="ParClassic" class="paragraph classic">
    <div class="paragraph-text">

      <div ref="Title" class="title">{{ title }}</div>
      <div class="paragraph-text-bottom">
        <div class="graphics">
          <div ref="SectionName" class="section-name">{{ $route.name }}</div>
          <span ref="Circle" class="circle"></span><span ref="Line" class="line vert"></span>
        </div>
        <div ref="Description">
          <div v-if="!abstract" class="description" v-html="description"></div>
          <div v-if="abstract" class="description" v-html="abstract"></div>
          <div class="module-cta">
            <a v-if="abstract" @click="show" class="button-white leggi-tutto">Leggi tutto</a>
          </div>

          <Attachments :attachments="module.moduli" v-if="module.moduli"/>
        </div>
      </div>
    </div>
    <div class="paragraph-image">
      <Images :images="module.immagine" v-if="module.immagine"/>
    </div>

    <transition name="fade">
      <div class="popup" v-if="overlay">
        <div class="popup-wrapper">
          <h2>{{ title }}</h2>
          <div class="abstract" v-html="description"></div>
          <a @click="hide" class="close-popup">Chiudi</a>
        </div>
      </div>
    </transition>

  </div>
</template>

<script>
  import Attachments from '@/components/elements/Attachments.vue';
  import Images from '@/components/elements/Images.vue';
  import {TimelineMax} from 'gsap'
  import ScrollMagic from 'scrollmagic'
  import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap'

  export default {
    name: 'classico',
    props: ['module'],
    data() {
      return {
        values: [],
        title: '',
        description: '',
        abstract: '',
        overlay: false,
        stopScroll: false,
        stopWindowScrollPosition: 0,
        controller: new ScrollMagic.Controller(),
      }
    },
    created() {
      this.title = this.module.titolo;
      try {
        this.abstract = this.module.abstract.value;
      }
      catch (e) {
      }
      this.description = this.module.descrizione.value;
    },
    mounted() {
      this.animations();
      $(window).scroll(function () {

        if (this.stopScroll === true) {
          $(window).scrollTop(this.stopWindowScrollPosition);
        }

      });
    },
    methods: {
      animations() {
        const vw = (coef) => window.innerWidth * (coef / 100)
        const vh = (coef) => window.innerHeight * (coef / 100)

        const {ParClassic} = this.$refs
        const {SectionName} = this.$refs
        const {Title} = this.$refs
        const {Description} = this.$refs
        const {Line} = this.$refs
        const {Circle} = this.$refs

        const timeline = new TimelineMax({paused: true})
        timeline.from(Title, 1, {opacity: 0, x: -20, ease: Power4.easeOut})
            .from(SectionName, 1, {opacity: 0, y: 10, ease: Power4.easeOut}, 0.9)
            .from(Description, 0.5, {opacity: 0, y: -10, ease: Power4.easeOut}, 0.6)
            .from(Line, 0.5, {opacity: 0, y: -10, ease: Power4.easeOut}, 0.7)
            .from(Circle, 0.5, {opacity: 0, y: -10, ease: Power4.easeOut}, 0.7);

        const scene = new ScrollMagic.Scene({
          triggerElement: ParClassic,
          triggerHook: 0.65,
          offset: 0
        }).on('enter', function (event) {
          timeline.play().timeScale(1);
        }).on('leave', function (event) {
          timeline.reverse().timeScale(1.5)
        }).addTo(this.controller);
      },
      show() {
        this.overlay = true;
        this.stopScroll = true;
        this.stopWindowScrollPosition = $(window).scrollTop();
      },
      hide() {
        this.overlay = false;
        this.stopScroll = 0;
      }
    },
    components: {
      Attachments,
      Images,
    }
  }
</script>
